import React, { useEffect, useState } from 'react'
import { profitLoss } from '../../footer/AccountFooter';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

const FloatingProfitLoss = () => {
    const [floatingPL, setFloatingPL] = useState(0)
    const { updatePL } = useSelector((state) => state.profitLoss);
    const { accountId: accountID } = useSelector(state => state.accountSummary)
    const accountId = localStorage.getItem("accountID") || accountID;
    // useEffect(() => {
    //     let pl = 0;
    //     if ([...profitLoss].length <= 0) {
    //         setFloatingPL(0);
    //         return;
    //     }
    //     [...profitLoss].map(item => {
    //         pl += parseFloat(item[1]) || 0
    //     })
    //     setFloatingPL(pl)
    // }, [updatePL,accountId])
    useEffect(() => {
        let pl = 0;

        for (const [key, value] of profitLoss) {
            if (key.startsWith(`${accountId}-`)) {
                pl += parseFloat(value) || 0;
            }
        }

        setFloatingPL(pl);
    }, [updatePL, accountId]);

    return (
        <Box sx={{ color: floatingPL < 0 ? 'var(--red)' : 'var(--green)' }}>{floatingPL.toFixed(2)}</Box>
    )
}

export default FloatingProfitLoss